// Icon.jsx

import React from 'react';

// Context
import { useIcons } from 'context/IconsContext';
import { useTheme } from 'context/ThemeContext';

// Utilities
import { getIconPath } from 'utilities/Icons';

/**
 * Icon
 *
 * @returns {ReactNode} The rendered component.
 */
const Icon = ({
  iconKey,
  path,
  color,
  width = '24',
  height = '24',
  viewBox = '0 -960 960 960',
}) => {

  // ----- CONTEXT ----- //

  // Icons Context

  const { iconsByKey } = useIcons();

  // Theme Context
  const { theme } = useTheme();

  const isIconsLoading = iconKey && iconsByKey === null;
  const resolvedPath = iconKey
    ? getIconPath(iconsByKey, iconKey, path)
    : typeof path === 'string'
      ? path.trim()
      : null;

  if (!resolvedPath) {
    if (iconKey && !isIconsLoading) {
      console.warn(`Icon could not resolve iconKey: ${iconKey}`);
    } else if (!iconKey) {
      console.warn('Icon requires a non-empty SVG path string.');
    }
    return null;
  }

  // ----- RENDER ----- //

  return (
    <svg height={height} width={width} viewBox={viewBox}>
      <path
        fill={color || theme.foreground}
        d={resolvedPath}
      />
    </svg>
  );
};

// Dev Tools
Icon.displayName = 'Icon';

export default React.memo(Icon);
